export default {
  signIn: 'Sign in',
  userError: 'Please input a user name',
  userPlaceholder: 'Please enter a user name',
  PWError: 'Please input a password',
  passPlaceholder: 'Please enter your password',
  PWSubError: 'Password must be more than 6 letters or numbers',
  captchaError: 'Please click the verification code to verify',
  signInSuccess: 'Login successful',
  loginTitle:
    'Modular distributed energy station technical and economic computing platform',
};
